import { Link } from 'react-router-dom';
import { articleLinks } from '@/mocks/categories';

export default function ArticleListSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-wider mb-2">
            Artykuły SEO
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
            Kompletny przewodnik po usfansspreadsheet
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            Poznaj wszystkie aspekty usfansspreadsheet — od podstaw po zaawansowane analizy. Nasze artykuły pomogą Ci w pełni wykorzystać potencjał tego narzędzia.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleLinks.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex flex-col rounded-2xl bg-background-100 border border-background-200/60 hover:border-accent-300/60 hover:translate-y-[-2px] transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-5 h-5 flex items-center justify-center rounded-md bg-accent-100 flex-shrink-0">
                    <i className="ri-article-line text-xs text-accent-600"></i>
                  </div>
                  <span className="text-xs text-foreground-400">Artykuł SEO</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors leading-snug mb-2 flex-1">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <div className="flex items-center gap-1.5 mt-3 pt-3 border-t border-background-200/60">
                  <span className="text-xs font-medium text-accent-600">Czytaj więcej</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs text-accent-600 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}